import { gql } from '@apollo/client';

export const LINK_PROCUREMENT_MANAGER = gql(/* GraphQL */ `
    mutation LinkProcurementExecutive($input: LinkExecutiveInput!) {
        linkExecutive(linkExecutiveInput: $input) {
            manager {
                id
                firstName
                lastName
                email
                faxNo
                mobileNo {
                    dialingCode
                    countryCode
                    number
                }
                telNo {
                    dialingCode
                    countryCode
                    number
                }
                speedDial
                designation
            }
            executive {
                id
                firstName
                lastName
                email
                faxNo
                mobileNo {
                    dialingCode
                    countryCode
                    number
                }
                telNo {
                    dialingCode
                    countryCode
                    number
                }
                speedDial
                designation
            }
            productCategories {
                id
                name
            }
        }
    }
`);

export default LINK_PROCUREMENT_MANAGER;
